import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

// Accordion
class AccordionCustom extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');

    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');

    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');

    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');

    return summary;
  }

  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }

  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }

  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#setDefaultOpenState();

    this.addEventListener('keydown', this.#handleKeyDown, { signal });
    this.summary.addEventListener('click', this.handleClick, { signal });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, { signal });
  }

  /**
   * Handles the disconnect event.
   */
  disconnectedCallback() {
    // Disconnect all the event listeners
    this.#controller.abort();
  }

  /**
   * Handles the click event.
   * @param {Event} event - The event.
   */
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;

    // Stop default behaviour from the browser
    if ((isMobile && this.#disableOnMobile) || (isDesktop && this.#disableOnDesktop)) {
      event.preventDefault();
      return;
    }
  };

  /**
   * Handles the media query change event.
   */
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };

  /**
   * Sets the default open state of the accordion based on the `open-by-default-on-mobile` and `open-by-default-on-desktop` attributes.
   */
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();

    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }

  /**
   * Handles keydown events for the accordion
   *
   * @param {KeyboardEvent} event - The keyboard event.
   */
  #handleKeyDown(event) {
    // Close the accordion when used as a menu
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();

      this.details.open = false;
      this.summary.focus();
    }
  }
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}

function scrollToSectionByHash(hash) {
    const sectionMap = {
        faq: 'text-block--AQzlQN3Bpb3habUI4U__text_VEb8NM'
    };

    if (hash && sectionMap[hash]) {
        const $target = $('.' + sectionMap[hash]);

        if ($target.length) {
            const headerOffset = 120;

            $('html, body').animate({
                scrollTop: $target.offset().top - headerOffset
            }, 800);
        }
    }
}


$(document).ready(function () {

  const hash = window.location.hash.replace('#', '');
  scrollToSectionByHash(hash);

  $('.overflow-menu li.menu-list__list-item:nth-child(5) a').on('click', function (e) {
    scrollToSectionByHash('faq');
  });


  // const sectionMap = {
  //       faq: 'text-block--AQzlQN3Bpb3habUI4U__text_VEb8NM'
  //   };

  //   const hash = window.location.hash.replace('#', '');

  //   if (hash && sectionMap[hash]) {
  //       const $target = $('.' + sectionMap[hash]);

  //       if ($target.length) {
  //           const headerOffset = 150; // adjust if you have fixed header

  //           $('html, body').animate({
  //               scrollTop: $target.offset().top - headerOffset
  //           }, 800);
  //       }
  //   }
});